/**
 * Formats a user's display name from name and surname, falling back to username
 * @param user - User object with name, surname, and username
 * @returns Formatted display name (e.g., "Jakub Vitek" or "vitekj" if name/surname not available)
 */
export function formatDisplayName(user: {
  name?: string | null;
  surname?: string | null;
  username: string;
}): string {
  if (user.name && user.surname) {
    return `${user.name} ${user.surname}`;
  }
  return user.username;
}

